import { useCallback, useEffect, useState } from 'react'

import useFirebase from './useFirebase'
import useUser from './useUser'

import { User } from '../../../types/RM'

export default function useUpdateUserData(): (
  obj: Partial<User>,
) => Promise<void> {
  const firebase = useFirebase()
  const [user] = useUser()
  const func = useCallback(
    (obj: Partial<User>) => {
      if (!user.auth?.uid) return

      return firebase.firestore().doc(`users/${user.auth.uid}`).update(obj)
    },
    [user.auth?.uid],
  )

  return func
}
